<template>
  <!--下载中心-->
  <tk-container
    :status="status"
    class="b-g-f"
    @refresh="getInit"
  >
    <my-header slot="header">下载中心</my-header>
    <div class="p-12">
      <tk-flex
        wrap
        gutter="11"
        class="card-shadow"
      >
        <card
          :height="193"
          class="tk-grid-6 card-shadow"
          v-for="(s, index) in downLoadList"
          @click.native="$push({ path: '/downLoad/downLoadFile', query: { type: s.type } })"
          :key="`tk-grid-6${index}`"
        >
          <tk-flex middle center column style="height: 160px;">
            <tk-image
              :replacement="false"
              width="39"
              height="34"
              :class="{ 'm-r-4': index === 3 }"
              style="margin-left: 1px;"
              :src="s.image"
            ></tk-image>
            <div class="m-t-16">{{s.text}}</div>
            <div class="font-14 m-t-5" style="color: #999;">{{s.count + '项'}}</div>
          </tk-flex>
        </card>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading',
      downLoadList: [
        {
          text: '图片',
          image: 'https://s3.moke.cloud/dianpei/b0ed4b02-aa7b-4e5b-89c9-bfd854751976.png',
          type: 'image',
          count: 0
        }, {
          text: '视频',
          image: 'https://s3.moke.cloud/dianpei/217b0b21-b1ed-4238-8898-ce9e9d92860f.png',
          type: 'video',
          count: 0
        }, {
          text: '音频',
          image: 'https://s3.moke.cloud/dianpei/e227ee4a-f60b-45c6-b7ad-fc99de18e5fb.png',
          type: 'audio',
          count: 0
        }, {
          text: '文件',
          image: 'https://s3.moke.cloud/dianpei/48644d69-e32d-4bda-82ae-f0311caeb5e3.png',
          type: 'file',
          count: 0
        }
      ]
    }
  },
  computed: {},
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/4/8
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        // this.downLoadList.forEach(s => {
        //   this.$tkParse.batch.get('/classes/downloadCenter', {
        //     params: {
        //       count: 1,
        //       limit: 0,
        //       where: {
        //         type: s.type
        //       }
        //     }
        //   })
        // })
        // let res = await this.$tkParse.batch.run()
        let res = []
        for (let i = 0; i < this.downLoadList.length; i++) {
          let s = this.downLoadList[i]
          let data = await this.$tkParse.get('/classes/downloadCenter', {
            params: {
              count: 1,
              limit: 0,
              where: {
                type: s.type
              }
            }
          })
          res.push(data)
        }
        res.forEach((s, index) => { this.downLoadList[index].count = s.data.count })
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-shadow {
  box-shadow: rgba(41, 42, 46, 0.1) 0 0 20px;
}
</style>
